export const genderOptions = [
    {key: 'male', text: 'Male', value: 'Male'},
    {key: 'female', text: 'Female', value: 'Female'},
    {key: 'other', text: 'Other', value: 'Other'},
];